import { Component, Input, OnInit, OnChanges, ViewEncapsulation, HostBinding, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { QueryCondition } from '../../entity/querycondition';
import { ControlType } from '../../entity/controltype';
import { SolutionService } from '../../service/solution.service';
import { CheckboxGroupControl } from '../../entity/controltype/checkbox/checkboxcontrol';
import { CheckboxValue } from '../../entity/controltype/checkbox/checkboxvalue';
import { CheckboxGroupValue } from '../../entity/conditionvalue/checkboxgroupvalue';

@Component({
    selector: 'app-filter-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss']
    // encapsulation: ViewEncapsulation.None
})

export class FilterCheckboxComponent implements OnInit, OnChanges {
    /**
     * QueryCondition类型
     */
    @Input() item: any;
    @Input() autoLabel: boolean;
    @Input() disabled: boolean;
    @Output() searchHandle = new EventEmitter();
    /** 判断是否是在扩展区域展示 */
    extend = false;
    /** 判断是否显示label */
    showlabel = true;
    checkValue: any[];

    selectCheck = [];

    @HostBinding('class.filter-item-wrap')
    get isExtend(): boolean {
        return !this.extend && this.autoLabel;
    }

    @HostBinding('class.filter-item-checbox-wrap')
    get isCheckExtend(): boolean {
        return !this.extend;
    }

    @HostBinding('class.filter-item-checkboxgroup') cla = true;
    @HostBinding('class.filter-item-hiddenlabel')
    get hidenLabel(): boolean {
        return !this.showlabel;
    }

    checkboxDataSource: Array<any> = new Array<any>();
    /**
     * 某个字段发生值变化事件时，需要同步清空的字段，可能不是当前字段
     */
    @Input() changeFields: Array<string> = [];
    constructor(private solutionService: SolutionService) { }

    ngOnInit(): void {
        this.getDataSource();
        this.checkValue = this.item.value.getOriginalValue();
        if (this.item && this.item.control && this.item.control.hasOwnProperty('isExtend')) {
            this.extend = this.item.control.isExtend;
            if (!this.extend) {
                this.showlabel = this.item.control.showLabel;
            }
        }

        this.solutionService.addFilterEditorInstance(this.item.fieldCode, this);


        (this.item.value as CheckboxGroupValue).clear$.subscribe( () => {
            this.checkValue = [];
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.getDataSource();
        if(changes['changeFields'] && changes['changeFields'].currentValue && !changes['changeFields'].firstChange) {
            const isChange = changes['changeFields'].currentValue.some(field => field == this.item.fieldCode);
            if(isChange){
                this.checkValue = (this.item.value as CheckboxGroupValue).getOriginalValue();
            }
        }
    }

    getDataSource() {
        if (this.item && this.item.control && this.item.control.getControlType() == ControlType.CheckboxGroup) {
            let checkboxList = (this.item.control as CheckboxGroupControl);
            this.checkboxDataSource = Array<CheckboxValue>();

            if (checkboxList.enumValues && checkboxList.enumValues.length > 0) {
                checkboxList.enumValues.forEach(element => {
                    this.checkboxDataSource.push(Object.assign(new CheckboxValue(), element));
                });
            }
        }
        // if(this.item && this.item.control && this.item.control.hasOwnProperty('isExtend')){
        //     this.extend = this.item.control.isExtend;
        // }
    }

    // getConditionItemStyle(field: QueryCondition, controlType: any) {
    //     return this.solutionService.getConditionItemStyle(field,controlType);
    // }

    getConditionItemTitle(field: QueryCondition) {
        return this.solutionService.getConditionItemTitle(field);
    }

    onSearch(event) {
        let checkboxValue = [];
        if (event) {
            // let checkboxList = event.split(',');
            let checkboxList = event;
            if (checkboxList && checkboxList.length) {
                checkboxValue = checkboxList;
            }
            this.item.value.value = checkboxValue;
        }
        else {
            this.item.value.value = new CheckboxGroupValue();
        }
        if (this.disabled) { return; }
        this.searchHandle.emit();
    }
}
